import { Meteor } from 'meteor/meteor';
import rateLimit from '../../modules/rate-limit';
import {
  annotationsFromVideo,
  copy,
  deleteAutomatic,
  hardDelete,
  hardManyDelete,
  insert,
  insertMany,
  update,
  updateElementValue,
  updateWithLocation,
  saveVideoEntities,
  checkFileJsonSchema
} from './server/annotation-methods-server';

Meteor.methods({
  'annotations.insert'(annotation, isPublic, userId = this.userId) {
    return insert(annotation, isPublic, userId);
  },
  'annotations.insertMany'(annotations, isPublic, userId = this.userId) {
    return insertMany(annotations, isPublic, userId);
  },
  'annotations.update'(annotation, isPublic, userId = this.userId) {
    return update(annotation, isPublic, userId);
  },
  'annotations.updateWithLocation'(annotation, isPublic, userId = this.userId) {
    return updateWithLocation(annotation, isPublic, userId);
  },
  'annotations.copy'(sourceVideoId, destVideoId) {
    return copy(sourceVideoId, destVideoId, this.userId);
  },
  'annotations.hardDelete'(annotationId, isValid) {
    hardDelete(annotationId, isValid);
  },
  'annotations.hardManyDelete'(videoId, isValid) {
    hardManyDelete(videoId, isValid);
  },
  'annotations.deleteAutomatic'(videoId) {
    deleteAutomatic(videoId);
  },
  'annotations.saveVideoEntities'(
    videoId,
    detectedEntities,
    template,
    featureArray,
    userId = this.userId
  ) {
    return saveVideoEntities(videoId, detectedEntities, template, featureArray, userId);
  },
  'annotations.annotationsFromVideo'(videoId) {
    return annotationsFromVideo(videoId);
  },
  'annotations.validate'(annotation, isPublic, userId = this.userId) {
    return checkFileJsonSchema(annotation, isPublic, userId);
  },
  'annotations.updateElementValue'(annotationId, elementOrder, newValue) {
    return updateElementValue(annotationId, elementOrder, newValue);
  }
});

rateLimit({
  methods: [
    'annotations.insert',
    'annotations.insertMany',
    'annotations.update',
    'annotations.hardDelete',
    'annotations.hardManyDelete',
    'annotations.deleteAutomatic',
    'annotations.saveVideoEntities',
    'annotations.validate',
    'annotations.updateElementValue',
    'annotations.updateWithLocation'
  ],
  limit: 5,
  timeRange: 1000
});
